<div class="modals ttn-status" [class.modals-show]="isNumberTtnModalShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <h4>Невірний номер декларації</h4>
  <button class="button" (click)="closeModal()">Зрозуміло</button>
</div>

<div class="dark-layer"
     [class.modals-show]="isDarkBackground"
     (click)="closeModal()">
</div>
